import React from 'react';

const EmptyState = ({ icon, title, subtitle, actionLabel, onAction }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center select-none">
    <div className="mb-5">
      {icon}
    </div>
    <h3 className="text-sm font-black text-slate-600 mb-1.5">{title}</h3>
    <p className="text-xs font-semibold text-slate-400 max-w-xs leading-relaxed">
      {subtitle}
    </p>
    {actionLabel && onAction && (
      <button
        onClick={onAction}
        className="mt-6 flex items-center gap-2 bg-[#0A3D73] hover:bg-[#082D54] text-white text-xs font-black uppercase px-5 h-9 rounded-lg shadow-sm transition-colors"
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
